"use client";

import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Desarrollo Inmobiliario",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/real_estate_development.png",
  description: "Lideramos proyectos desde la adquisición del terreno hasta la entrega de llaves, garantizando excelencia en cada etapa del desarrollo inmobiliario con visión estratégica.",
  link: "#",
  className: "h-[450px]"
}, {
  title: "Construcción",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/construction_site.png",
  description: "Ejecución de obras con los más altos estándares de calidad y precisión técnica, utilizando materiales premium y mano de obra altamente calificada.",
  link: "#",
  className: "h-[450px]"
}, {
  title: "Inversión",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/investment_growth.png",
  description: "Estrategias de inversión personalizadas diseñadas para maximizar la rentabilidad y asegurar el crecimiento patrimonial sólido de nuestros clientes.",
  link: "#",
  className: "h-[450px]"
}, {
  title: "Proyectos",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/architectural_projects.png",
  description: "Gestión integral de proyectos arquitectónicos, desde el diseño conceptual innovador hasta la planificación técnica y gerenciamiento de obra.",
  link: "#",
  className: "h-[450px]"
}];
export default function ServicesSection() {
  const [flipped, setFlipped] = useState<Record<number, boolean>>({});
  const toggleFlip = (index: number) => {
    setFlipped(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="90955" id="áreas-de-especialización" className="py-32 text-foreground !bg-[hsl(0,0%,96%)]">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl font-default font-bold mb-6 tracking-tight uppercase !font-serif !text-[hsl(42,50%,70%)] md:text-5xl lg:text-6xl">SERVICIOS</h2>
          <p className="text-lg max-w-2xl mx-auto leading-relaxed !font-serif !bg-transparent !text-[hsl(203,55%,13%)] md:text-xl">
            Impulsamos el mercado inmobiliario argentino con proyectos de vanguardia, construcción de alta gama y estrategias de inversión diseñadas para el éxito a largo plazo.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, i) => <Card key={i} data-index={i} onClick={() => toggleFlip(i)} className={`group relative overflow-hidden border border-border rounded-2xl shadow-md p-0 cursor-pointer transition-colors duration-500 ${service.className}`}>
              
              <div className={`absolute inset-0 transition-all duration-500 ease-out ${flipped[i] ? "opacity-0 pointer-events-none -translate-y-4" : "opacity-100 translate-y-0"}`}>
                <img src={service.image} alt={service.title} className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-in-out saturate-50 group-hover:scale-105" />
                
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent transition-opacity duration-500" />
                
                <CardContent className="absolute inset-0 flex flex-col justify-end gap-y-6 p-6 md:p-8 z-10">
                  <h3 className="font-default text-3xl md:text-4xl text-white font-bold uppercase text-center min-h-[5rem] flex items-center justify-center">
                    {service.title}
                  </h3>
                  
                  <div className="flex justify-center opacity-0 transition-all duration-500 ease-out group-hover:opacity-100">
                    <Button size="lg" style={i === 0 ? {
                  backgroundColor: "#0B182A",
                  color: "#FFFFFF",
                  borderRadius: "18px",
                  border: "1px solid rgba(255,255,255,0.12)",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.25)"
                } : undefined} className={`${i === 0 ? "hover:!bg-[#13233b]" : "bg-[#0B182A] hover:bg-[#13233b] rounded-2xl border border-white/10"} !text-white hover:!text-white transition-all duration-300 hover:scale-105`}>
                      Ver Detalles
                      <ArrowRight className="ml-2 size-4" />
                    </Button>
                  </div>
                </CardContent>
              </div>

              <div className={`absolute inset-0 bg-secondary flex flex-col justify-end gap-y-6 p-6 md:p-8 transition-all duration-500 ease-out z-20 ${flipped[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}>
                <h3 className="font-default text-2xl md:text-3xl text-white font-bold uppercase text-center min-h-[5rem] flex items-center justify-center">
                  {service.title}
                </h3>
                <p className="text-white/80 text-lg !font-serif leading-relaxed text-center">
                  {service.description}
                </p>
                <div className="flex justify-center">
                  <Button variant="outline" size="lg" className="font-bold uppercase border-white text-white hover:bg-white hover:text-secondary">
                    Volver
                  </Button>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}